import styled from 'styled-components';
import { Disableable, getSpacingToken, getToken, VISUALLY_HIDDEN } from '@optimus-web/common';
import { Icon } from '../Icon';
import { Body, Typography } from '../typography';
import { getBackgroundColor, getBorderColor } from './getDropzoneStyles';

interface Props extends Disableable {
    error: boolean;
    isDragging?: boolean;
}

export const DropzoneContainer = styled.div<Props>`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${getSpacingToken('200')}px;
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};
    border-width: ${getToken('borderWidth150')}px;
    border-style: dashed;
    border-color: ${(props) => getBorderColor(props)};
    border-radius: ${getToken('borderRadius100')}px;
    padding: ${getSpacingToken('500')}px ${getSpacingToken('300')}px;
    background-color: ${(props) => getBackgroundColor(props)};
`;

export const UploadTextWrapper = styled.div`
    text-align: center;
`;

export const DropzoneText = styled(Body).attrs({ size: 'small' })<Props>`
    color: ${({ error, disabled }) => getToken(!error && !disabled ? 'textStaticPrimary' : 'textDisabled')};
`;

export const UploadIcon = styled(Icon)<Props>`
    color: ${({ error, disabled }) => getToken(!error && !disabled ? 'textStaticPrimary' : 'textDisabled')};
`;

export const InvisibleInput = styled.input`
    ${VISUALLY_HIDDEN}
`;
export const RightTopPositioner = styled.div<Disableable>`
    position: absolute;
    top: ${getSpacingToken('100')}px;
    right: ${getSpacingToken('100')}px;
    cursor: pointer;
    opacity: ${({ disabled }) => (disabled ? getToken('opacity400') : getToken('opacity1000'))};
`;

export const FilesContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${getSpacingToken('200')}px;
    border: ${getToken('borderWidth150')}px solid ${getToken('borderStaticPrimary')};
    border-radius: ${getToken('borderRadius100')}px;
    padding: ${getSpacingToken('150')}px ${getSpacingToken('100')}px ${getSpacingToken('150')}px
        ${getSpacingToken('150')}px;
    margin-top: ${getSpacingToken('100')}px;
`;

export const FileNameWrapper = styled.div`
    margin-right: auto;
`;

export const FileNameContainer = styled(Typography)`
    word-break: break-word;
`;
